import { Fragment, useEffect, useRef, useState } from "react";
import DraggableSidebar from "../components/DraggableSidebar";
import { useNavigate, Link, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import checkCircle from "../assets/images/check-circle.png";
import validationSchema from "../ValidationScheema/Yup";
import { useFormik } from "formik";
import { signupUser } from "../Store/api/studentAuth";
import Loader from "../components/Loader";
import { studentIvite } from "../Store/api/studentInvite";
import { setSiteMode, resetSiteMode } from "../Store/settings/siteSettings";
import { useSelector } from "react-redux";
import { me } from "../Store/api/student";
import storage from "../services/storage";

import Payment from "../components/studentpayment/Payment";
import StudentSignupSidebar from "../components/studentDashboard/StudentSignupSidebar";
import http from "../services/http";
import { toast } from "react-toastify";

const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  confirmPassword: "",
};

export const StudentSection = (props) => {
  const { stripePromise } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const timeoutRef = useRef(null);
  const { joinCode, tab = 0 } = useParams();
  const [clasInfo, setClasInfo] = useState(0);
  const [loading, setLoading] = useState(false);
  const [classDetail, setClassDetail] = useState();
  const [studentTab, setStudentTab] = useState(tab);
  const [messageBody, setMessageBody] = useState("");
  const [sectionData, setSectionData] = useState(null);
  const [sectionDetail, setSectionDetail] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const { user, token } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(setSiteMode("student"));
    return () => {
      dispatch(resetSiteMode());
    };
  }, [dispatch]);

  useEffect(() => {
    if (user && token && user.isEnrolled) {
      navigate("/studentdashboard/overview");
    } else if (user && token && !user.isEnrolled) {
      setStudentTab(2);
    } else {
      setStudentTab(0);
    }
  }, [user, token, navigate]);

  useEffect(() => {
    dispatch(
      studentIvite({
        joinCode,
        onSuccess: (res) => {
          setSectionData(res.data.data.all_sectionData[0]);
          setSectionDetail(res.data.data.detail_TA);
          setClassDetail(res.data.data);
        },
      })
    );
  }, [dispatch, joinCode]);

  useEffect(() => {
    if (!stripePromise) return;

    // stripePromise.then(async (stripe) => {
    const url = new URL(window.location);
    const clientSecret = url.searchParams.get("payment_intent_client_secret");
    const paymentIntent = url.searchParams.get("payment_intent");
    if (!clientSecret || !paymentIntent) return;
    setMessageBody("");

    dispatch(
      me({
        onSuccess: (res) => {
          storage.store("user", res.data.data);
          setStudentTab(2);
          setClasInfo(4);
        },
        onError: (error) => {},
      })
    );
  }, [dispatch, stripePromise]);

  const {
    values,
    errors,
    touched,
    setFieldError,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values, action) => {
      setLoading(true);
      dispatch(
        signupUser({
          body: {
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            password: values.password,
            role: "STUDENT",
            joinCode,
          },
          onSuccess: () => {
            setStudentTab(2);
            setClasInfo(0);
            setLoading(false);
            action.resetForm();
          },
          onError: (err) => {
            const {
              isStudentExistInSystem = false,
              isStudentExistInCLassAndSection = false,
              AssociatedWithAnotherSectionInClass = false,
            } = err?.response?.data?.data;
            let errorMessage = "";

            if (isStudentExistInCLassAndSection)
              errorMessage = (
                <>
                  This email is already associated with this class and section. 
                  If you've forgotten your login, 
                  <u
                    className="text-black fw-500"
                    onClick={() => navigate("/forgotPassword")}
                  >
                    Reset your password
                  </u>
                  here.
                </>
              );
            else if (AssociatedWithAnotherSectionInClass)
              errorMessage =
                "This email is already associated with another section in this class. Please reach out to your professor and ask to move sections.";
            else if (isStudentExistInSystem)
              errorMessage =
                "This email is already associated with a Greyled account.";

            setLoading(false);
            if (err?.response?.data?.message) {
              toast.error(err.response.data.message);
            } else {
              setErrorMessage(errorMessage);
            }
          },
        })
      );
    },
  });

  const checkEmailExists = async () => {
    try {
      // Simulating an API call (Replace with actual API request)
      const { data = {} } = await http.post({
        url: "api/student/check-email",
        body: { email: values.email, joinCode },
      });
      const {
        isStudentExistInSystem = false,
        isStudentExistInCLassAndSection = false,
        AssociatedWithAnotherSectionInClass = false,
      } = data?.data;
      let errorMessage = "";

      if (isStudentExistInCLassAndSection)
        errorMessage = (
          <>
            This email is already associated with this class and section. 
            If you've forgotten your login, 
            <u
              className="text-black fw-500"
              onClick={() => navigate("/forgotPassword")}
            >
              Reset your password
            </u>
            here.
          </>
        );
      else if (AssociatedWithAnotherSectionInClass)
        errorMessage =
          "This email is already associated with another section in this class. Please reach out to your professor and ask to move sections.";
      else if (isStudentExistInSystem)
        errorMessage =
          "This email is already associated with a Greyled account.";

      errorMessage && setFieldError("email", errorMessage);
    } catch (error) {
      console.error("Error checking email:", error);
    }
  };

  useEffect(() => {
    if (values.email) {
      // Clear existing timeout if user types again
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // Set new timeout for API call
      timeoutRef.current = setTimeout(() => {
        checkEmailExists(values.email);
      }, 2000);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [values.email]);

  return (
    <div className="flex-container">
      <div
        className="activity-spectrum"
        style={{ marginBottom: "-3%", height: "100%" }}
      >
        <div>
          <DraggableSidebar />
        </div>
      </div>

      <div style={{ width: "100%" }}>
        <section className="class_room_wrap">
          <div className="custom_container" style={{ height: "100vh" }}>
            <div className="row   ">
              <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-12 px-0  mt-0 pb-0">
                <StudentSignupSidebar
                  joinCode={joinCode}
                  sectionData={sectionData}
                  classDetail={classDetail}
                  sectionDetail={sectionDetail}
                />
              </div>
              <div
                className="col-xxl-9 col-xl-9 col-lg-8"
                style={{ height: "100vh", padding: "0px" }}
              >
                <div
                  className="welcome_wrap custom_nav pr-50 pt-16 mt-0 main_content_tabs"
                  style={{
                    paddingTop: "85px",
                    overflowY: "clip",
                    height: "100%",
                  }}
                >
                  <div
                    className="col-xl-9 col-lg-10 "
                    style={{ width: "69.4%" }}
                  >
                    <div className="main_wrap_new  book-width">
                      <ul
                        className="nav nav-tabs nav-justified"
                        id="myTab"
                        role="tablist"
                      >
                        <li
                          className="nav-item"
                          role="presentation"
                          /* onClick={() => {
                        setStudentTab(0);
                      }} */
                        >
                          <button
                            className={
                              studentTab === 0 ? "nav-link active" : "nav-link "
                            }
                            id="home-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#class-info1"
                            type="button"
                            role="tab"
                            aria-controls="class-info1"
                            aria-selected="true"
                          >
                            <div className="col-xxl-9 col-xl-9 col-lg-12 ">
                              class info
                            </div>
                          </button>
                        </li>

                        <li
                          className="nav-item"
                          role="presentation"
                          onClick={() => {
                            // setStudentTab(1);
                          }}
                        >
                          <button
                            className={
                              studentTab === 1 ? "nav-link active" : "nav-link "
                            }
                            id="account_creation-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#account_creation"
                            type="button"
                            role="tab"
                            aria-controls="profile"
                            aria-selected="false"
                          >
                            account creation
                          </button>
                        </li>
                        <li
                          className="nav-item"
                          role="presentation"
                          onClick={() => {
                            // setStudentTab(1);
                          }}
                        >
                          <button
                            className={
                              studentTab === 2 ? "nav-link active" : "nav-link "
                            }
                            id="payment_information-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#payment_information"
                            type="button"
                            role="tab"
                            aria-controls="payment_information"
                            aria-selected="false"
                          >
                            payment information
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className="tab-content"
                    id="ClassInfo"
                    style={{ width: "69.4%" }}
                  >
                    <div
                      className={
                        studentTab === 0
                          ? "tab-pane fade show active"
                          : "tab-pane fade show "
                      }
                      style={{
                        width: "100%",
                        justifyContent: "center",
                        // display: "none",
                      }}
                      id="class-info1"
                      role="tabpanel"
                      aria-labelledby="class-info1-tab"
                    >
                      <div className="row class_info_wrap book-width">
                        <div
                          className="col-xl-9 col-lg-10"
                          style={{ padding: "0px", width: "100%" }}
                        >
                          {clasInfo === 0 ? (
                            <div
                              className="main_wrap_new book-width pt-85"
                              style={{
                                overflowY: "scroll",
                                height: "70vh",
                              }}
                            >
                              {sectionData ? (
                                <div className="main_content_inner book-width ">
                                  {/* <!-- welcome to  --> */}
                                  <h1 className="main_title  ">
                                    Welcome to{" "}
                                    <span className="bg_lit">
                                      {sectionData.sectionName}
                                    </span>{" "}
                                    with{" "}
                                    <span className="bg_lit">
                                      prof. {sectionData.createdBy.lastName}
                                    </span>{" "}
                                    {/*  at{" "}
                                  <span className="bg_lit">
                                    the university of iowa
                                  </span> */}
                                  </h1>
                                  <p className="f24 mb-0">
                                    You are in{" "}
                                    <span className="bg_lit">
                                      Section{" "}
                                      {sectionData.sectionNumber.split("-")[0]},
                                    </span>{" "}
                                    with{" "}
                                    {sectionData.instructorEmails.map(
                                      (instructor, index, arr) => (
                                        <span
                                          key={instructor._id}
                                          className="bg_lit"
                                        >
                                          {sectionDetail[instructor.email]
                                            ? `${
                                                sectionDetail[instructor.email]
                                                  .firstName
                                              } ${
                                                sectionDetail[instructor.email]
                                                  .lastName
                                              }`
                                            : instructor.email}
                                          {arr.length > 2 &&
                                            index !== arr.length - 1 &&
                                            ", "}
                                          {index === arr.length - 2 && (
                                            <span className="emptt"> and </span>
                                          )}
                                        </span>
                                      )
                                    )}{" "}
                                    as your{" "}
                                    {sectionData.instructorEmails.length > 1 ? (
                                      <span>instructors</span>
                                    ) : (
                                      <span>instructor</span>
                                    )}
                                    .
                                  </p>

                                  <div className="btn_wrap_info that-correct">
                                    <button
                                      type="button"
                                      className="btn_black_theme"
                                      onClick={() => {
                                        setClasInfo(1);
                                      }}
                                    >
                                      That’s correct
                                    </button>
                                    {/* <button
                                      type="button"
                                      className="btn_outline_dark mt_24"
                                    >
                                      Alert Professor about incorrect
                                      information
                                    </button> */}
                                  </div>
                                </div>
                              ) : (
                                <div className="loader">
                                  <Loader />
                                </div>
                              )}
                            </div>
                          ) : (
                            ""
                          )}
                          {clasInfo === 1 ? (
                            <div
                              className="main_wrap_new pt-85 book-width"
                              style={{ overflowY: "scroll", height: "70vh" }}
                            >
                              {/* <div className="main_wrap_new w-768 pt-132 d-none"> */}
                              <div className="main_content_inner">
                                <h1 className="main_title  ">
                                  Your class uses resources on greyled
                                </h1>
                                <p className="f24 mb-0">
                                  We’re a new learning platform that leverages
                                  community-created resources to remove barriers
                                  between professors, their students, and the
                                  knowledge that helps them reach their full
                                  potential
                                </p>

                                <div className="btn_wrap_info that-correct">
                                  <button
                                    type="button"
                                    className="btn_black_theme"
                                    onClick={() => {
                                      setStudentTab(1);
                                    }}
                                  >
                                    Sign me up
                                  </button>
                                  <button
                                    type="button"
                                    className="btn_outline_dark mt_24"
                                    onClick={() => {
                                      // window.location.href =
                                      //   "https://greyled.com/";
                                    }}
                                  >
                                    Tell me more about Greyled
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                    {/*Student create an account to access class materials*/}
                    <div
                      className={
                        studentTab === 1
                          ? "tab-pane fade show active"
                          : "tab-pane fade show  "
                      }
                      id="account_creation"
                      role="tabpanel"
                      aria-labelledby="account_creation"
                    >
                      {clasInfo === 1 && (
                        <div
                          className="main_wrap_new pt-85 "
                          style={{
                            overflowY: "scroll",
                            height: "77vh",
                            overflowX: "clip",
                          }}
                        >
                          <div
                            className="welcome_wrap pl-0"
                            style={{ paddingRight: "0px", overflowX: "clip" }}
                          >
                            <h1 className="main_title mb-4   ">
                              create an account to access class materials
                            </h1>
                            <form onSubmit={handleSubmit}>
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="First name"
                                      name="firstName"
                                      value={values.firstName}
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      autoComplete="off"
                                    />{" "}
                                    <div className="err-end">
                                      {errors.firstName && touched.firstName ? (
                                        <p className="error-msg">
                                          {errors.firstName}
                                        </p>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Last name"
                                      name="lastName"
                                      value={values.lastName}
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      autoComplete="off"
                                    />{" "}
                                    <div className="err-end">
                                      {errors.lastName && touched.lastName ? (
                                        <p className="error-msg">
                                          {errors.lastName}
                                        </p>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-12">
                                  <div className="form-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="University email address"
                                      name="email"
                                      value={values.email}
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      autoComplete="off"
                                    />{" "}
                                    <div className="err-end">
                                      {/* {errors.email && touched.email ? ( */}
                                      <p className="error-msg">
                                        {errorMessage || errors.email}
                                      </p>
                                      {/* ) : null} */}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <input
                                      type="Password"
                                      className="form-control"
                                      name="password"
                                      placeholder="Password"
                                      value={values.password}
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      autoComplete="off"
                                    />{" "}
                                    <div className="err-end">
                                      {errors.password && touched.password ? (
                                        <p className="error-msg">
                                          {errors.password}
                                        </p>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <input
                                      type="Password"
                                      className="form-control"
                                      placeholder="Confirm password"
                                      name="confirmPassword"
                                      value={values.confirmPassword}
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      autoComplete="off"
                                    />{" "}
                                    <div className="err-end">
                                      {errors.confirmPassword &&
                                      touched.confirmPassword ? (
                                        <p className="error-msg">
                                          {errors.confirmPassword}
                                        </p>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-12">
                                  <div className="btn_Wrap mt-30">
                                    <button
                                      type="submit"
                                      className="btn_black_theme w-100 d-block"
                                      disabled={loading ? true : false}
                                    >
                                      {loading ? (
                                        <div className="loader">
                                          <Loader />
                                        </div>
                                      ) : (
                                        "Sign up"
                                      )}
                                    </button>
                                    <p className="agrre-to mt-20 pb-55 pdl-8">
                                      By signing up, you agree to be contacted
                                      by greyled and its partners.{" "}
                                      <a
                                        href="https://greyled.com/"
                                        className="font-whi"
                                      >
                                        Learn more
                                      </a>
                                    </p>
                                    {/* {errorMessage.message && (
                                      <div
                                        className={`alert alert-${errorMessage.type}`}>
                                        {errorMessage.message}
                                      </div>
                                    )} */}
                                    {/* <p className="btn_link mt-20 pb-55">
                                  By signing up, you agree to be contacted by
                                  greyled and its partners.{" "}
                                  <a href="" className="font-whi">
                                    <u>Learn more</u>
                                  </a>
                                </p> */}
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      )}

                      {/* low cost subscription */}

                      {/* thank you! */}
                      {studentTab === 3 && (
                        <div
                          className={"tab-pane fade show active"}
                          id="thank_you"
                          role="tabpanel"
                          aria-labelledby="thank_you"
                        >
                          {ThankYou()}
                        </div>
                      )}
                    </div>
                    {studentTab === 2 && (
                      <div
                        className="tab-pane fade show active"
                        id="payment_information"
                        role="tabpanel"
                        aria-labelledby="payment_information"
                      >
                        {clasInfo !== 4 ? (
                          <Payment
                            stripePromise={stripePromise}
                            joinCode={joinCode}
                          />
                        ) : (
                          <Fragment>{ThankYou()}</Fragment>
                        )}
                      </div>
                    )}
                    {studentTab >= 2 ? (
                      <Fragment></Fragment>
                    ) : (
                      <div className="footer_bottom stud_sec_footer_bot">
                        <p className="have-account">
                          Already have an account?{" "}
                          <Link to={`/?joinCode=${joinCode}`}>Sign in</Link>
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );

  function ThankYou() {
    return (
      <div className="main_wrap_new book-width pt-85 ">
        {messageBody ? (
          <div
            style={{
              color: "red",
              fontSize: "18px",
              fontWeight: "bolder",
              marginBottom: "160px",
              marginTop: "132px",
              textAlign: "center",
            }}
          >
            Error in payment: {messageBody}
          </div>
        ) : (
          <div className="main_content_inner">
            <h1 className="main_title  ">thank you!</h1>
            <p className="f24 mb-0">
              Payment confirmation and receipt sent to email used to create your
              account. Payment information can be updated at any time in your
              account settings.
            </p>
            <div className="check_img text-center mt_26">
              <img alt="" src={checkCircle} />
            </div>

            <div className="btn_wrap_info that-correct">
              <button
                type="button"
                className="btn_black_theme"
                onClick={() => {
                  navigate("/studentdashboard/overview");
                }}
              >
                Start learning
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
};
